<ngx-ui-loader></ngx-ui-loader>
<div id="accounting-account" class="page-layout simple tabbed">
<accounting-account-header [complexId]="complexId"></accounting-account-header>
  <div class="page-wrapper">
    <complex-selector (complexConn)="sendComplexId($event)"></complex-selector>
    <category-table [complexId]="complexId"></category-table>
  </div>
</div>